import type { SVGProps } from 'react';

export const TransitionsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M9.66615 2.66647H14.3328C16.3578 2.66647 17.9995 4.30809 17.9995 6.33313V17.6664C17.9995 19.6915 16.3578 21.3331 14.3328 21.3331H9.66615C7.64111 21.3331 5.9995 19.6915 5.9995 17.6664V6.33313C5.9995 4.30809 7.64111 2.66647 9.66615 2.66647ZM3.66617 6.66646H3.9995C4.5515 6.66646 4.9995 6.21846 4.9995 5.66647C4.9995 5.11447 4.5515 4.66647 3.9995 4.66647H3.66617C2.01284 4.66647 0.666176 6.0118 0.666176 7.66646V16.3331C0.666176 17.9878 2.01284 19.3331 3.66617 19.3331H3.9995C4.5515 19.3331 4.9995 18.8851 4.9995 18.3331C4.9995 17.7811 4.5515 17.3331 3.9995 17.3331H3.66617C3.1155 17.3331 2.66617 16.8851 2.66617 16.3331V7.66646C2.66617 7.11446 3.1155 6.66646 3.66617 6.66646ZM20.3328 4.66647H19.9995C19.4475 4.66647 18.9995 5.11447 18.9995 5.66647C18.9995 6.21846 19.4475 6.66646 19.9995 6.66646H20.3328C20.8835 6.66646 21.3328 7.11446 21.3328 7.66646V16.3331C21.3328 16.8851 20.8835 17.3331 20.3328 17.3331H19.9995C19.4475 17.3331 18.9995 17.7811 18.9995 18.3331C18.9995 18.8851 19.4475 19.3331 19.9995 19.3331H20.3328C21.9861 19.3331 23.3328 17.9878 23.3328 16.3331V7.66646C23.3328 6.0118 21.9861 4.66647 20.3328 4.66647Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
